<app-fd-unauthenticated-card *ngIf="!isServer">
    <div class="content login-height">
        <div class="content__header">
            <img *ngIf="isDarkMode" class="content__img" src="assets/images/Fraud_Deflect_logo2-removebg.png">
            <img *ngIf="!isDarkMode" class="content__img" src="assets/images/fraud_deflect_horizontal.jpg">
            <h1 class="content__title" i18n>Login to your account</h1>
        </div>
        <form [formGroup]="signInForm" (ngSubmit)="signIn()" (blur)="hideError()" class="content__form">
            <div *ngIf="signInError" class="content__error-banner">{{signInErrorMsg}}</div>
            <mat-form-field floatLabel="always" appearance="outline">
                <mat-label i18n>Email Address</mat-label>
                <input matInput i18n-placeholder placeholder="Enter your Email address" [formControl]="email" name="email" height="48px">
                @if(email.dirty && email.invalid && email.errors?.['required']){
                <mat-error i18n>Email is required</mat-error>
                }
                @else if (email.dirty && email.invalid && email.errors?.['minlength']) {
                <mat-error i18n>Email should be atleast 3 characters</mat-error>
                }
                @else if (email.dirty && email.invalid && email.errors?.['email']) {
                <mat-error i18n>Email has incorrect format</mat-error>
                }
            </mat-form-field>

            <mat-form-field floatLabel="always" appearance="outline" class="content__field">
                <mat-label i18n>Password</mat-label>
                <input matInput i18n-placeholder placeholder="Enter your Password" [formControl]="password"
                    [type]="visiblePassword ? 'text' : 'password'" name="password" height="48px">
                <button type="button" mat-icon-button (click)="showPassword()" matSuffix>
                    <mat-icon>{{ visiblePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                </button>
                <mat-error *ngIf="password.dirty && password.invalid && password.errors?.['required']" i18n>Password is
                    required</mat-error>
                <mat-error *ngIf="password.dirty && password.invalid && password.errors?.['minlength']" i18n>Password
                    should be
                    atleast 8 characters</mat-error>
            </mat-form-field>
            <div class="content__actions-container">
                <mat-checkbox [formControl]="rememberMe" i18n>Remember me</mat-checkbox>
                <div class="content__link"><a href="forgot-password" i18n>Forgot Password</a></div>
            </div>
            <button class="content__button" type="submit" [disabled]="signInForm.invalid" mat-raised-button
                color="primary" i18n>Login</button>
        </form>
    </div>
</app-fd-unauthenticated-card>